<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-link"></i> Atalhos</h3>
      </div>
    </div>
    <LinkAdd v-if="showAdd" ref="LinkAdd" v-on:Back="onBack" />
    <LinkList v-else ref="LinkList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import LinkAdd from './components/add/linkadd.vue'
import LinkList from './components/list/linklist.vue'

export default {
  name: 'Pa',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    LinkAdd,
    LinkList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.LinkAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.LinkList.onLoad()
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/links/links.vue